import React, { useEffect } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
    Box,
    Text,
    Card,
    CardBody,
    Button,
    Stack,
    Flex,
    CardFooter
} from '@chakra-ui/react';
import { customColors } from '../utils/customColors';
import { FaThList } from 'react-icons/fa';
import { IoChevronForwardOutline } from 'react-icons/io5';

export function SortableItemVideo(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: "70%",
        align: "center",
        justifyContent: "left",
        display: "flex",
        alignItems: "bottom",
        marginLeft: "29%",

    };

    const ref = React.useRef(null);


    const handleClick = () => {
        //console.log("props.id", props.id)
        props.myfunc(props.id, props.title);
    };




    return (

        <Flex
            style={style}
        /*  display="flex" */

        >

            <Card
                borderBottomRightRadius={"5px"}
                borderTopRightRadius={"5px"}

                mr="0px"
                mt="10px"
                w="60%"
                color={customColors.textPalette1}
                bg={customColors.appColor4}
                ref={setNodeRef}
                {...attributes}
                {...listeners}

            >
                <CardBody
                    ref={ref}
                >
                    <Box /* display="flex" */ alignItems="center" justifyContent="center">
                        <Text align="center" as="b">{props.title}</Text>
                    </Box>
                </CardBody>
            </Card>
        </Flex >
    );
}